import store from "@/store";

export const getHoursAndMinutes = (date: Date) => {
  const d = new Date(date);
  const hour = d.getHours();
  const min = d.getMinutes() < 10 ? `0${d.getMinutes()}` : d.getMinutes();

  return `${hour}:${min}`;
};

export const isArrayEmpty = (arr: any[]): boolean => {
  return !arr || arr.length === 0 || !Array.isArray(arr);
};

export const isStrEmpty = (str: string): boolean => {
  return !str || str.length === 0;
};

export const isObjEmpty = (obj: any): boolean => {
  return !obj || Object.keys(obj).length === 0;
};

export const formatDate = (
  date: Date
): {
  minutes: string | number;
  day: string | number;
  month: string | number;
  monthName: string;
  monthFullName: string;
  year: number;
  convertHours: string;
  dayName: string;
  hour24h: string | number;
  seconds: string | number;
} => {
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "June",
    "July",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const monthFullNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  let hours = date.getHours();
  let minutes: string | number = date.getMinutes();
  let seconds: string | number = "";
  const dayName = days[date.getDay()];
  const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
  const month =
    date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
  const monthName = monthNames[date.getMonth()];
  const monthFullName = monthFullNames[date.getMonth()];

  const year = date.getFullYear();
  const convertHours = hours >= 12 ? "pm" : "am";
  const hour24h = hours < 10 ? "0" + hours : hours;
  hours = hours % 12;
  hours = hours ? hours : 12;
  minutes = minutes < 10 ? "0" + minutes : minutes;

  seconds =
    date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();

  const param = {
    hours,
    minutes,
    day,
    month,
    monthName,
    monthFullName,
    year,
    convertHours,
    dayName,
    hour24h,
    seconds,
  };

  return param;
};

export const fixedNumber = (number: number | string, numberFixed = 2) => {
  const n = Number(number);
  if (Number.isNaN(n)) {
    return number;
  }
  return n.toFixed(numberFixed);
};

export const parseStakeAmount = (value: number | string | null | undefined): number => {
  if (value == null || value === "") return NaN;
  const normalized = String(value).trim().replace(",", ".");
  return parseFloat(normalized);
};

/** Validates stake against min; max applies only when betMax is a positive number. */
export const isStakeInRange = (
  amount: number,
  betMin: number,
  betMax?: number | null
): boolean => {
  if (Number.isNaN(amount)) return false;
  const stake = Math.round(amount * 100) / 100;
  const min = Math.round(betMin * 100) / 100;
  if (stake < min) return false;
  if (
    betMax != null &&
    !Number.isNaN(betMax) &&
    betMax > 0 &&
    stake > betMax
  ) {
    return false;
  }
  return true;
};

export const isValidBetAmount = (
  value: number,
  betMin?: number | null,
  betMax?: number | null,
) => {
  const min = betMin ?? 0;
  if (value < min) return false;
  if (betMax == null) return true;
  return value <= betMax;
};

export const sortBy = (array: any[], key: string) => {
  return array.sort((a, b) => a[key] - b[key]);
};

export const formatDateTimeZone = (
  date: string | Date
) => {
  const dateTime = new Date(date);

  // Sử dụng local time thay vì timezone cụ thể
  const hour = dateTime.getHours().toString().padStart(2, "0");
  const minutes = dateTime.getMinutes().toString().padStart(2, "0");
  const seconds = dateTime.getSeconds().toString().padStart(2, "0");
  const day = dateTime.getDate().toString().padStart(2, "0");
  const month = (dateTime.getMonth() + 1).toString().padStart(2, "0");
  const year = dateTime.getFullYear().toString();

  // Tính toán tuần dựa trên local time
  const startOfWeek = new Date(
    dateTime.getFullYear(),
    dateTime.getMonth(),
    dateTime.getDate() - dateTime.getDay() + 1
  );
  const weekDates: string[] = [];

  for (let i = 0; i < 7; i++) {
    const weekDate = new Date(
      startOfWeek.getFullYear(),
      startOfWeek.getMonth(),
      startOfWeek.getDate() + i
    );
    const formattedDate = `${weekDate.getDate().toString().padStart(2, "0")}/${(
      weekDate.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}/${weekDate.getFullYear().toString()}`;
    weekDates.push(formattedDate);
  }

  const result = {
    hour,
    minutes,
    seconds,
    day,
    month,
    year,
    weekDates,
  };

  return result;
};

export const groupByKey = (array: any[], key: string) => {
  const result = array.reduce(function (r, a) {
    r[a[key]] = r[a[key]] || [];
    r[a[key]].push(a);
    return r;
  }, Object.create(null));

  const groupArrays = Object.keys(result).map((value) => {
    return {
      item: value,
      list: result[value],
    };
  });

  return groupArrays;
};

export const getParamQueryTheme = (key: string): string => {
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const account = params.get(key) || "";
  return account;
};

export const compareDateTime = (date1, date2, timeZoneString = "UTC") => {
  const formattedDate1 = formatDateTimeZone(date1);
  const formattedDate2 = formatDateTimeZone(date2);

  const parsedDate1 = new Date(
    `${formattedDate1.year}-${formattedDate1.month}-${formattedDate1.day}T${formattedDate1.hour}:${formattedDate1.minutes}:${formattedDate1.seconds}`
  );

  const parsedDate2 = new Date(
    `${formattedDate2.year}-${formattedDate2.month}-${formattedDate2.day}T${formattedDate2.hour}:${formattedDate2.minutes}:${formattedDate2.seconds}`
  );

  if (parsedDate1 < parsedDate2) {
    return -1;
  } else if (parsedDate1 > parsedDate2) {
    return 1;
  } else {
    return 0;
  }
};

export const compareDates = (date1, date2, timeZoneString) => {
  const formattedDate1 = formatDateTimeZone(date1);
  const formattedDate2 = formatDateTimeZone(date2);

  const d1 = new Date(
    `${formattedDate1.year}-${formattedDate1.month}-${formattedDate1.day}T${formattedDate1.hour}:${formattedDate1.minutes}:${formattedDate1.seconds}`
  );

  const d2 = new Date(
    `${formattedDate2.year}-${formattedDate2.month}-${formattedDate2.day}T${formattedDate2.hour}:${formattedDate2.minutes}:${formattedDate2.seconds}`
  );
  d1.setHours(0, 0, 0, 0);
  d2.setHours(0, 0, 0, 0);

  if (d1.getTime() < d2.getTime()) {
    return -1;
  } else if (d1 > d2) {
    return 1;
  } else {
    return 0;
  }
};

export const isNumber = (s) => {
  return !isNaN(parseFloat(s)) && isFinite(s);
};

export const getStateVueX = () => {
  return JSON.parse(JSON.stringify(store.state));
};

export const getSettings = () => {
  const state = getStateVueX();
  const settings = state.settings;
  return settings;
};

type DebouncedFunction<T extends (...args: any[]) => void> = T & {
  cancel: () => void;
};

export const debounce = <T extends (...args: any[]) => void>(
  func: T,
  wait: number,
): DebouncedFunction<T> => {
  let timeout: ReturnType<typeof setTimeout> | undefined;
  const debounced = function (this: ThisParameterType<T>, ...args: Parameters<T>) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  } as DebouncedFunction<T>;

  debounced.cancel = () => {
    clearTimeout(timeout);
  };

  return debounced;
};
